module.exports = __webpack_public_path__ + "img/pg.6ccbd7f.svg";